export const succsesDataChangeAlert = () => {
    alert("Успішно змінено!");
};

export const succsesDataAddAlert = () => {
    alert("Успішно додано!");
};

export const succsesDataDeleteAlert = () => {
    alert("Успішно видалено!");
};

export const errorAlert = () => {
    alert("Щось пішло не так, спробуйде ще раз!");
};

export const permissionAlert = () => {
    alert("На жаль, ви не маєте доступу для данної дії!");
};
